import { useContext } from 'react';
import { AppInfoContext } from './appInfoContextObject';

/**
 * Whether classification markings (CAPCO) are enabled for this deployment
 * (`info.capco.enabled` from `/api/info`). Forms use it to decide whether a
 * marked text shows its marking control.
 *
 * It answers `true` only on an enabled answer. While `/api/info` is loading,
 * after it failed, and outside `AppInfoProvider` (where `useAppInfo` throws)
 * it answers `false`: the plain form, with no marking control. The forms
 * hold and save each stored marking whatever this answers, so `false` never
 * loses or lowers one.
 */
export function useCapcoEnabled(): boolean {
  const ctx = useContext(AppInfoContext);
  // The same truthiness test the classification banner uses (AppLayout).
  return !!ctx?.info?.capco?.enabled;
}
